export const SESSION_STORE_KEY = '_dd_s';
//# sourceMappingURL=sessionStoreStrategy.js.map


// WEBPACK FOOTER //
// ./~/@datadog/browser-rum-core/~/@datadog/browser-core/esm/domain/session/storeStrategies/sessionStoreStrategy.js